import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';  // Import Swiper components
import 'swiper/swiper-bundle.css'; // Import Swiper styles
import { Autoplay, Thumbs, Mousewheel } from 'swiper/modules';  // Import necessary Swiper modules
import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link, useParams } from 'react-router-dom';
import { FaPlay } from "react-icons/fa";
import { withRouter } from 'react-router-dom'; // Import withRouter to access location in class components
import data from './data';




import GamesData from '../../../WC_Api/WB_Category_Wise_Data.json';
import GamesSwiper from '../../../WC_Api/GamesSwiper';
import WB_api_page_tabs from '../../../WC_Api/WB_api_page_tabs';
import NewRegister from '../Auth/NewRegister';


const GridContainerNew = styled.div`
  // display: grid;
  gap: 5px;
  // border:1px solid pink; 
  // border-radius: 0 20px 20px 20px;
  width: 100%;
  height:100%;
  // top:10px;
  display: flex;
  overflow: hidden;
  padding: 0 0.5rem;
  padding-top:2.2rem;

  justify-content: center;
  align-items: center;
  //  grid-template-columns: repeat(7, minmax(200px, 1fr));
  // grid-gap: 10px; 
  // padding-right: 17px;
  // overflow-x: auto; /* Enables horizontal scrolling */
  // white-space: nowrap; /* Prevents line breaks, so content stays in a single line */
  // Mobile view (1 columns)
  // grid-template-columns: repeat(7, 1fr); /* Creates 3 equal columns */
  // grid-template-rows: 1fr; /* Only one row */

   // Tablet view (2 columns)
  // @media (min-width: 340px) {
  //   grid-template-columns: repeat(2, 1fr);
  // }

  // Tablet view (3 columns)
  // @media (min-width: 768px) {
  //   grid-template-columns: repeat(3, 1fr);
  // }

  // Desktop view (4 columns)
  // @media (min-width: 1024px) {
  //   grid-template-columns: repeat(5, 1fr);
  // }

  // Large Desktop view (6 columns)
  // @media (min-width: 1440px) {
  //   grid-template-columns: repeat(6, 1fr);
  // }
`;

const GridItem = styled.div`
  background-color: transparent;
  width: 100%;
  border-radius: 10px;

  // overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.4); /* Background color on hover */
  }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;
   
    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }
    
`;


const GridItemprovider = styled.div`
  background-color:#000;
  width: 100%;
  // height:70px;
  border-radius: 10px;
  padding:9px 12px;

// border:1px solid green;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */
  
    }

  &:hover {
    // background-color: rgba(0, 0, 0, 0.4); /* Background color on hover */
  cursor:pointer;
    }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;
   
    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }
    
`;
const GamesSlotWrapper = styled.div`
  // background-color: #1C1E22;
  // padding: 2px;
  // border:1px solid red;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  // position: relative;
  margin-top: 40px !important;
  //  margin-top: 100px !important;
  // @media (max-width: 768px) {
  //   margin-top: 100px !important;
  // }
`;

const ResponsiveImage = styled.img`
  object-fit: cover;
  width: 100%;  // Adjusts image width to fill the container
  height: auto; // Maintains aspect ratio for responsiveness
// border:1px solid red;

 

  @media (min-width: 467px) {
    width: 100%;
    height: auto;
    
  }
`;

const AllButtonRigthTitleContainer = styled.div`

  position: absolute;
  display:flex;
  gap:10px;
  width:100%;
  align-items:center;
 justify-content:space-between;
  top: -34px; //vivek
  // right: 0;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  margin: 0;
`;

const AllButtonTopTitleContainer = styled.div`
  background-color: #1C1E22;
  border-radius: 15px;
  display:flex;
  justify-caontent:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px 20px;
  margin: 0;
  cursor:pointer;

  @media (max-width: 350px) {
    display:none;
  }
`;
const PaginationButton = styled.div`
  background-color: #1C1E22;
  border-radius: 50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px;

`;

class MyComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exampleState: 'Hello, React!',
      searchQuery: '',
      tempSearchQuery: '',
      selectedFilter: "all",
      games: data,
      gameData2: GamesData
    };
    this.swiperRef = React.createRef();
    this.swiperRef8 = React.createRef();

  }
 
  componentDidMount() {
  this.handleRouteChange();
}

componentDidUpdate(prevProps) {
  if (this.props.location.pathname !== prevProps.location.pathname) {
    this.handleRouteChange();
  }
}

handleRouteChange() {
  const { pathname } = this.props.location;
  const categories = [
    { key: 'all', label: 'Lobby', path: '/casino' },
    { key: 'Originals', label: 'Originals', path: '/casino/Originals' },
    { key: 'hot-games', label: 'Hot Games', path: '/casino/hot-games' },
    { key: 'slots', label: 'Slot Games', path: '/casino/slots' },
    { key: 'live-casino', label: 'Live Casino', path: '/casino/live-casino' },
    { key: 'sports', label: 'Sports', path: '/casino/sports' },
    { key: 'providers', label: 'Providers', path: '/casino/providers' },
  ];

  const matchedCategory = categories.find((category) =>
    pathname.includes(category.key)
  );

  if (matchedCategory) {
    this.handleFilterChange(matchedCategory.key);
  } else {
    this.handleFilterChange("all");
  }
}


  // Custom method for next slide
  nextSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  };


  nextSlideHandler8 = () => {
    if (this.swiperRef8.current && this.swiperRef8.current.swiper) {
      this.swiperRef8.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler8 = () => {
    if (this.swiperRef8.current && this.swiperRef8.current.swiper) {
      this.swiperRef8.current.swiper.slidePrev();
    }
  };

  handleSearchChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      // If input is cleared, update searchQuery immediately
      if (this.state.searchQuery !== "") {
        this.setState({ searchQuery: "", tempSearchQuery: "" });
      }
    } else {
      // Store input separately to prevent re-renders
      if (this.state.tempSearchQuery !== value) {
        this.setState({ tempSearchQuery: value });
      }
    }
  };

  handleSearchKeyPress = (e) => {
    if (e.key === "Enter" && this.state.searchQuery !== this.state.tempSearchQuery) {
      this.setState({ searchQuery: this.state.tempSearchQuery });
    }
  };





  handleFilterChange = (category) => {
    const componentMap = {
      'Originals': WB_api_page_tabs,
      'hot-games': WB_api_page_tabs,
      'slots': WB_api_page_tabs,
      'live-casino': WB_api_page_tabs,
      'sports': WB_api_page_tabs,
      'providers': WB_api_page_tabs,
    };

    this.setState({ selectedFilter: category, selectedComponent: componentMap[category] || null });
  };


  // Filter games based on search query and selected filter
  getFilteredGames = () => {
    const { games, searchQuery, selectedFilter } = this.state;

    return games

      .filter((game) =>
        game.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .filter(
        (game) => selectedFilter === 'all' || game.category === selectedFilter

      );


  };

  render() {
    const { searchQuery, selectedFilter } = this.state;
    const { pathname } = this.props.location ?? {};
    // Filtered Originals Games for Lobby

    const providers = this.getFilteredGames().filter(
      (game) => game.category === 'providers'
    );

    

    const allowedCategoryKeys = (process.env.REACT_APP_CATEGORIES || '')
      .split(',')
      .map(key => key.trim())
      .filter(Boolean);
      
    
    const categories = [
      { key: 'all', label: 'Lobby', icon: 'lobby.svg', path: '/casino' },
      { key: 'Originals', label: 'Originals', icon: 'BCOriginal.svg', path: '/casino/Originals' },
      { key: 'hot-games', label: 'Hot Games', icon: 'hotGames.svg', path: '/casino/hot-games' },
      { key: 'slots', label: 'Slot Games', icon: 'slot.svg', path: '/casino/slots' },
      { key: 'live-casino', label: 'Live Casino', icon: 'liveCasino.svg', path: '/casino/live-casino' },
      { key: 'sports', label: 'Sports', icon: 'slot.svg', path: '/casino/sports' },
      { key: 'providers', label: 'Providers', icon: 'providers.svg', path: '/casino/providers' },
    ];

    const filteredCategories = categories.filter(cat =>
      allowedCategoryKeys.includes(cat.key)
    );

    const { selectedComponent: SelectedComponent } = this.state;
    return (
      <div>
        {/* header image */}
        <div className='bc-home-banner'>
        <img className='bcgame-home-banner-img' src='/assets/bcimages/bchome/bcgame-home-banner.webp'/>
        <img className='bcgame-home-banner-img2' src='/assets/bcimages/bchome/bcgame-home-banner2.webp'/>
        <img className='bcgame-home-icon-img' src='/assets/bcimages/bchome/bcgame-home-icon.webp'/>
        <img className='bcgame-home-logo-img' src='/assets/bcimages/bchome/bcgame-home-logo.webp'/>
        <div className='bcgame-banner-contant'>
          <p>Stay Untamed</p>
          <div className='bcgame-banner-contant-middle'>
            <div className='bcgame-banner-signup-text'>Sign Up & Get</div>        
            <span className='bcgame-banner-contant-middle-span1'>UP TO</span>
            <span className='bcgame-banner-contant-middle-span2'>$1,697,058.59</span>          
            <div className='bcgame-banner-contant-incasino'>in Games or Sports</div>
          </div>
          {/* <button onClick={() => setShowRegister(true)}>Join Now</button>
          {showRegister && <Register />} */}
         
            <NewRegister/>
        </div>
      </div>

        <div className="casino-container" >
          {/* Search Bar */}
          <div className="search-container" style={{ position: 'relative' }}>
            <input
              type="text"
              value={this.state.tempSearchQuery} // Use tempSearchQuery for real-time typing
              onChange={this.handleSearchChange}
              onKeyDown={this.handleSearchKeyPress}
              placeholder="Search games"
              className="search-input"
              style={{ fontWeight: "700", paddingLeft: "40px" }} // Space for the icon
            />

            <img
              src="/assets/bcimages/Casino/svgexport-1 (1).svg"
              alt="search"
              style={{
                position: 'absolute',
                left: '10px',
                top: '65%',
                width: '25px',
                height: '25px',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            />
          </div>

          <div className="filter-buttons mt-5" >
            {filteredCategories.map(({ key, label, icon, path }) => {
              console.log(key)
              const isActive =
                (key === 'all' && (pathname === '/casino' || !categories.some((cat) => pathname.includes(cat.key)))) ||
                pathname.includes(key);
              return (
                <Link key={key} to={path}>
                  <div
                    className={`filter-button ${isActive ? 'active' : ''}`}
                    onClick={() => this.handleFilterChange(key)}
                  >
                    <img src={`/assets/bcimages/Casino/${icon}`} className="filter-btn-img" />  {/* Corrected src */}
                    {label}
                  </div>
                </Link>
              );
            })}
          </div>

          {SelectedComponent ? <SelectedComponent gameData={this.state.gameData2} category={this.state.selectedFilter} /> : ""}


          <div>
            <GamesSlotWrapper>
              {categories
                .filter((category) => category.key !== 'providers' && category.key !== 'all') // Exclude "providers" and "all"
                .map((category) => (
                  (selectedFilter === 'all') && (
                    <GamesSwiper
                      key={category.key}
                      gameData={GamesData}
                      category={category.key}
                      searchQuery2={searchQuery}
                    />
                  )
                ))}
            </GamesSlotWrapper>


            {/* providers */}
            <GamesSlotWrapper>
              {selectedFilter === 'all' && providers.length > 0 && (
                <GridContainerNew className="game-slider" >


                  <Swiper
                    spaceBetween={10}
                    loop={true}
                    slidesPerView={7}
                    thumbs={true}
                    // mousewheel={true}
                    modules={[Autoplay, Thumbs, Mousewheel]}
                    className="mySwiper"
                    ref={this.swiperRef8} // Attach the ref to Swiper
                    breakpoints={{
                      1200: { slidesPerView: 7 },
                      1024: { slidesPerView: 5 },
                      768: { slidesPerView: 4 },
                      480: { slidesPerView: 3 },
                      300: { slidesPerView: 2 },
                      250: { slidesPerView: 1 },
                      0: { slidesPerView: 1 },
                    }}
                  >

                    <AllButtonRigthTitleContainer>
                      <div style={{ display: "flex" }}>
                        <div className="bc-slider-text" style={{ color: "white", fontSize: '17px', fontWeight: 'bold', marginLeft: "15px", }}>
                          Game Providers
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <Link to={"/casino/providers"}>
                          <AllButtonTopTitleContainer>All</AllButtonTopTitleContainer>
                        </Link>
                        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>

                          <PaginationButton onClick={this.prevSlideHandler8}>
                            <ChevronLeft size={20} />
                          </PaginationButton>

                          <PaginationButton onClick={this.nextSlideHandler8}>
                            <ChevronRight size={20} />
                          </PaginationButton>
                        </div>
                      </div>
                    </AllButtonRigthTitleContainer>

                    {providers.map((game, index) => (
                      <SwiperSlide key={index}>
                        <GridItemprovider>
                          <div className="game-image-provider">
                            <ResponsiveImage src={game.imagePath} alt={game.name} className="swiper-slide-img-provider" />
                          </div>
                          <div className="play-container">
                            <i className="fa fa-play play-icon"></i>
                          </div>
                        </GridItemprovider>
                      </SwiperSlide>
                    ))}



                  </Swiper>

                </GridContainerNew>
              )}
            </GamesSlotWrapper>
          </div>






        </div>
      </div>
    );
  }
}

export default withRouter(MyComponent);

